import script from "./StructureTab.vue?vue&type=script&setup=true&lang=js"
export * from "./StructureTab.vue?vue&type=script&setup=true&lang=js"

import "./StructureTab.vue?vue&type=style&index=0&id=585ef120&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-585ef120"]])

export default __exports__